<template>
    <div class="section">
        <div class="container-fluid">
            <div class="">
                <div class="container ">
                    <div class="columns" style="padding-top: 50px;">
                        <div class="column is-5-desktop">
                            <h1 class="title has-text-centered">Edit Payment Refund</h1>
                            <transition name="fade">
                                <div v-if="alertMessage" class="alert-message is-success has-text-centered">
                                    {{ alertMessage }}
                                </div>
                            </transition>
                            <form>
                                <div class="field select-client-field">
                                    <div class="control">
                                        <model-select :options="options"
                                                      v-model="user"
                                                      :isDisabled="true"
                                                      class="input"
                                                      placeholder="Select Client">
                                        </model-select>
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <datetime
                                                input-class="input"
                                                v-model="transactionDate"
                                                :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                                type="date"
                                                value-zone="local"
                                                zone="local"
                                                placeholder="Select date"
                                        ></datetime>
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <textarea v-model="description" class="textarea"
                                                  placeholder="Description"></textarea>
                                    </div>
                                </div>

                                <div class="field">
                                    <div class="control text-center">
                                        <a @click.prevent="editRefundTransaction" class="button is-primary">Submit</a>
                                        <router-link
                                                tag="button"
                                                to="/banking"
                                                class="button is-danger">
                                            <span>Cancel</span>
                                        </router-link>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="column is-offset-2-desktop">
                            <h1 class="title has-text-centered">Select a payment</h1>
                            <div class="client-amount-table-container">
                                <div class="card">
                                    <div class="card-content">
                                        <div class="theme-table-container table-container center-column w-100">
                                            <table class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped">
                                                <thead>
                                                <tr>
                                                    <th class="payment"><span @click="setOrder('manager_id')"
                                                              class="link">Payment #</span></th>
                                                    <th class="amount"><span @click="setOrder('manager_id')" class="link">Amount</span>
                                                    </th>
                                                    <th class="balance"><span @click="setOrder('manager_id')"
                                                              class="link">Balance</span></th>
                                                    <th class="refund_amount"><span @click="setOrder('manager_id')"
                                                              class="link">Refund Amount</span></th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td class="payment">#{{ customerPayment.id }}</td>
                                                    <td class="amount">¥{{ customerPayment.amount | formatNumber }}</td>
                                                    <td class="balance">¥{{ customerPayment.unused_amount | formatNumber }}</td>
                                                    <td class="refund_amount">
                                                        <div class="field paid-amount-field">
                                                            <p class="control used_amount-field is-fullwidth">
                                                                <input class="input" type="text"
                                                                       v-model="customerPayment.refund_amount">
                                                            </p>
                                                        </div>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {ModelSelect} from 'vue-search-select'
    import apiUsers from './../../api/apiUsers'
    import {Datetime} from 'vue-datetime'
    import UnpaidInvoiceTableRow from "./UnpaidInvoiceTableRow";
    import apiProformaInvoices from "../../api/apiProformaInvoices";
    import UnpaidMultiInvoiceTableRow from "./UnpaidMultiInvoiceTableRow";
    import CustomerPaymentTableRow from "./CustomerPaymentTableRow";

    export default {
        components: {
            ModelSelect,
            Datetime
        },
        data() {
            return {
                options: [],
                type: 2,

            }
        },
        computed: {
            alertMessage: function () {
                return this.$store.getters.getTransactionStatus
            },
            customerPayment: function () {
                return this.$store.getters.getCustomerPayment
            },
            user: {
                get() {
                    return this.$store.getters.getTransactionClient;
                },
                set(value) {
                    this.$store.commit('setTransactionClient', value)
                }
            },
            transactionDate: {
                get() {
                    return this.$store.getters.getTransactionDate
                },
                set(value) {
                    this.$store.commit('setTransactionDate', value)
                }
            },
            description: {
                get() {
                    return this.$store.getters.getTransactionDescription;
                },
                set(value) {
                    this.$store.commit('setTransactionDescription', value)
                }
            }
        },
        methods: {
            editRefundTransaction() {
                let customerPayment = this.customerPayment
                //let multiInvoices = this.unpaidMultiInvoices
                let data = {
                    client_id: this.user,
                    amount: this.customerPayment.refund_amount,
                    type: 2,
                    transaction_date: this.transactionDate,
                    description: this.description,
                    payment: customerPayment,
                }
                this.$store.dispatch('editRefundTransaction', {data: data, id: this.$route.params.id})
            },
            setSelectOptions(users) {
                let list = []

                users.forEach(function (element) {
                    list.push({
                        value: element.id,
                        text: element.name
                    })
                })

                this.options = list
            }
        },
        mounted() {
            this.$store.dispatch('getRefundTransaction', this.$route.params.id)
            this.$store.commit('setTransactionStatus', '')
            apiUsers
                .requestAllUsers()
                .then((response) => {
                    this.setSelectOptions(response.data)
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }
</script>

<style scoped>

    .field.select-client-field .control {
        display: flex;
    }

    .field.select-client-field .control button.button.is-primary {
        margin-left: 10px;
        align-self: center;
    }

    .alert-message {
        margin-bottom: 10px;
    }

    table.table.client-amount-table {
        width: 100%;
    }

    .error-alert {
        background-color: #ffecec;
        color: #b94a48;
        padding: 5px 10px;
        border: 1px solid #ffdde2;
        border-radius: 5px;
        margin-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Banking/EditRefundTransaction.vue